// Popup newsletter de l'app Shopify Forms : sur mobile, la boîte flottante
// touche les bords de l'écran (son wrapper plein écran `_floating_*` n'a
// aucun padding latéral). L'app rend le popup dans <shopify-forms-embed>
// (shadow DOM ouvert) — hors de portée du CSS du thème et sans réglage
// mobile dans l'admin Forms. On injecte donc une feuille de style dans le
// shadow root. Les classes internes sont hashées par build (`_floating_1q1d2_52`),
// d'où les sélecteurs [class*="…"] qui survivent aux mises à jour de l'app.
// !important requis : les adoptedStyleSheets de l'app passent après nos <style>
// dans la cascade.

const SIDE_GAP_PX = 6;
const TOP_GAP_PX = 28;
const BOTTOM_GAP_PX = 12;

// La boîte (`_grid_*`) est aussi bridée en hauteur : l'app la laisse monter
// jusqu'à 90vh (et la racine passe à height:100% sur mobile), d'où un popup
// collé en haut et en bas sur un formulaire long.
const css = `
@media screen and (max-width: 768px) {
  [class*='_floating_'] {
    padding: ${TOP_GAP_PX}px ${SIDE_GAP_PX}px ${BOTTOM_GAP_PX}px !important;
    box-sizing: border-box !important;
  }
  [class*='_grid_'] {
    max-height: calc(100dvh - ${TOP_GAP_PX + BOTTOM_GAP_PX}px) !important;
  }
}`;

/** @param {Element} embed */
const inject = (embed) => {
  const root = embed.shadowRoot;
  if (!root || root.querySelector('style[data-fred-popup-margins]')) return;
  const style = document.createElement('style');
  style.setAttribute('data-fred-popup-margins', '');
  style.textContent = css;
  root.append(style);
};

// Le popup est ajouté au DOM avec un délai (déclencheur de l'app) : on
// surveille son apparition en continu — plusieurs embeds possibles (teaser…).
const scan = () => document.querySelectorAll('shopify-forms-embed').forEach(inject);

scan();
new MutationObserver(scan).observe(document.body, { childList: true, subtree: true });
